var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var body = document.querySelector("body");
var sticky = 0;

// Font Resizer-------------------Start
function fontResizer() {
  var perc = parseInt(sw) / 118.9375;
  document.body.style.fontSize = perc + "px";
}

// Loader-------------------Start
function pageLoader() {
  setTimeout(function () {
    document.querySelector(".loader-first").style.display = "none";
    document.querySelector("html").classList.remove("loadjs");
  }, 700);
}

// Navigation Active-------------------Start
let toggleMenu = document.querySelector("#toggle");
let htmlEl = document.querySelector("html");
let navBtn = document.querySelector(".nav-button");

toggleMenu.addEventListener("click", function () {
  {
    navBtn.classList.toggle("active");
    document.querySelector(".navigation").classList.toggle("open");
    htmlEl.classList.toggle("overflow-hidden");
  }
});
// Navigation Active-------------------End

// Footer Accordion-------------------Start
var accordion = document.getElementsByClassName("footer__links");
var j;

for (j = 0; j < accordion.length; j++) {
  accordion[j].querySelector(".head").addEventListener("click", function () {
    this.classList.toggle("opened");
    var panel = this.nextElementSibling;
    panel.classList.toggle("opened");
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}
// Footer Accordion-------------------End

// Landscape Mode off----------------Start
function landscapeModeOff() {
  if (sh < 450 && sw > 480 && sw < 820) {
    document.getElementById("portrait-warnning").style.display = "flex";
  } else {
    document.getElementById("portrait-warnning").style.display = "none";
  }
}

// Sticky Header----------------Start
function stickyHeader() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

// SVG Covert Code

let svgs = document.querySelectorAll("img.svg-convert");

svgs.forEach((el) => {
  const imgID = el.getAttribute("id");
  const imgClass = el.getAttribute("class");
  const imgURL = el.getAttribute("src");

  fetch(imgURL)
    .then((response) => response.text())
    .then((data) => {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(data, "text/html");
      let svg = xmlDoc.querySelector("svg");
      if (typeof imgID !== "undefined") {
        svg.setAttribute("id", imgID);
      }

      if (typeof imgClass !== "undefined") {
        svg.setAttribute("class", imgClass + " svg-converted");
      }

      svg.removeAttribute("xmlns:a");

      el.parentNode.replaceChild(svg, el);
    });
});

// Window on Load-----------------Start
window.onload = function () {
  pageLoader();
  if (sw > 1025) {
    fontResizer();
  }
};

// Window On Resize-----------------Start
window.addEventListener("resize", (event) => {
  sw = window.innerWidth;
  sh = window.innerHeight;
  landscapeModeOff();
  if (sw > 1025) {
    if (sw < 1400 && sw > 1300 && sh > 900) {
    } else {
      fontResizer();
    }
  }
});

// Window On Resize-----------------End

// Window On Scroll-----------------Start
window.addEventListener("scroll", (event) => {
  stickyHeader();
});
// Window On Scroll-----------------End

// Mega Menu---Start

if (sw < 1199 || (sw < 1400 && sw > 1300 && sh > 900)) {
  allItem = document.querySelectorAll(".menuArrow");
  allItem.forEach((item) => {
    item.addEventListener("click", toggleClass);
  });

  function toggleClass() {
    var itemClass = this.parentElement.parentElement.className;
    [...this.parentElement.parentElement.parentElement.children].forEach(
      (menuItem) => {
        menuItem.classList.remove("active");
      }
    );
    if (itemClass.includes("active")) {
      his.parentElement.parentElement.classList.remove("active");
    } else {
      this.parentElement.parentElement.classList.add("active");
    }
  }
}

if (sw > 1199) {
  if (sw < 1400 && sw > 1300 && sh > 900) {
  } else {
    [].forEach.call(
      document.querySelectorAll(".menu .menu__item"),
      function (link) {
        link.addEventListener("mouseover", coloringHandler);
        link.addEventListener("mouseout", decoloringHandler);
      }
    );

    function coloringHandler() {
      this.classList.add("active");
    }

    function decoloringHandler() {
      this.classList.remove("active");
    }
  }
}

// Mega Menu---End

// Language Dropdown Active-------------------Start

if ("ontouchstart" in document.documentElement) {
  let selectedItem = document.querySelector(".langWrapper");
  selectedItem.addEventListener("click", () => {
    selectedItem.classList.toggle("open");

    // only for sticky Email
  });
} else {
  let selectedItem = document.querySelector(".langWrapper");

  selectedItem.addEventListener("mouseenter", () => {
    selectedItem.classList.add("open");
  });
  selectedItem.addEventListener("mouseleave", () => {
    selectedItem.classList.remove("open");
  });

  let allEmailWrapper = document.querySelectorAll(".emailWrapper");
  allEmailWrapper.forEach((emailWrapper) => {
    emailWrapper.classList.add("sticky");
    console.log("hahahaha");
  });
}
// Language Dropdown Active-------------------End

// -------------------- above code will be common for all pages --------------------------

// Homepage Sliders---Start
if (document.querySelector(".homeHero__bgSlider")) {
  let heroSlidertotalSlide = document.querySelectorAll(
    ".homeHero__bgSlider .swiper-slide"
  ).length;
  var homeHero__bgSlider = new Swiper(".homeHero__bgSlider", {
    slidesPerView: 1,
    loop: false,
    speed: 800,
    allowTouchMove: false,
    observeParents: true,
    observer: true,
    effect: "fade",
    fadeEffect: {
      crossFade: false,
    },
    pagination: {
      el: ".homeHero__bgNavigation .swiper-pagination",
      type: "progressbar",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        // pagination--Start
        var currentSlide = document.querySelector(
          ".homeHero__bgNavigation .current-slide"
        );
        var allSlides = document.querySelector(
          ".homeHero__bgNavigation .total-slides"
        );
        var current = this.realIndex + 1;
        if (current > heroSlidertotalSlide) current = 1;
        var idx = current < 10 ? "0" + current : current;
        var tdx =
          heroSlidertotalSlide < 10
            ? "0" + heroSlidertotalSlide
            : heroSlidertotalSlide;
        currentSlide.innerHTML = idx;
        allSlides.innerHTML = tdx;
        // pagination--End
      },
      resize: function () {
        this.update();
      },
    },
  });
  homeHero__bgSlider.on("slideChange", function () {
    // pagination--Start
    var currentSlide = document.querySelector(
      ".homeHero__bgNavigation .current-slide"
    );
    var allSlides = document.querySelector(
      ".homeHero__bgNavigation .total-slides"
    );
    var current = this.realIndex + 1;
    if (current > heroSlidertotalSlide) current = 1;
    var idx = current < 10 ? "0" + current : current;
    var tdx =
      heroSlidertotalSlide < 10
        ? "0" + heroSlidertotalSlide
        : heroSlidertotalSlide;
    currentSlide.innerHTML = idx;
    allSlides.innerHTML = tdx;
    // pagination--End
  });
}
if (document.querySelector(".btmSlider__imgSlider")) {
  var btmSlider__imgSlider = new Swiper(".btmSlider__imgSlider", {
    slidesPerView: 1,
    loop: false,
    speed: 800,
    allowTouchMove: true,
    observeParents: true,
    observer: true,
    grabCursor: true,
    pagination: {
      el: ".btmSlider__wrapper .swiper-pagination",
      clickable: true,
    },
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });
}

// Homepage Sliders---End

// // Homepage Media Section Tabs-- Start
// window.addEventListener("load", function () {
//   // store tabs variable
//   var myTabs = document.querySelectorAll(".genericTabs .tab-item");
//   function myTabClicks(tabClickEvent) {
//     var clickedTab = tabClickEvent.currentTarget;
//     var allTabs = clickedTab.parentNode.children;
//     for (var i = 0; i < allTabs.length; i++) {
//       allTabs[i].classList.remove("active");
//     }
//     clickedTab.classList.add("active");
//     tabClickEvent.preventDefault();

//     var anchorReference = tabClickEvent.target;
//     var activePaneId = anchorReference.getAttribute("href");
//     var activePane = document.querySelector(activePaneId);
//     var allTabsContent = activePane.parentNode.children;
//     for (i = 0; i < allTabsContent.length; i++) {
//       allTabsContent[i].classList.remove("active");
//     }
//     activePane.classList.add("active");
//   }
//   for (i = 0; i < myTabs.length; i++) {
//     myTabs[i].addEventListener("click", myTabClicks);
//   }
// });
// // Homepage Media Section Tabs-- End

// Homepage Media Section Tabs-- Start
window.addEventListener("load", function () {
  // store tabs variable
  var myTabs = document.querySelectorAll(".genericTabs .tab-item");
  function myTabClicks(tabClickEvent) {
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].classList.remove("active");
    }
    var clickedTab = tabClickEvent.currentTarget;
    clickedTab.classList.add("active");
    tabClickEvent.preventDefault();
    var myContentPanes = document.querySelectorAll(
      ".genericTabsContent .content-item"
    );
    for (i = 0; i < myContentPanes.length; i++) {
      myContentPanes[i].classList.remove("active");
    }
    var anchorReference = tabClickEvent.target;
    var activePaneId = anchorReference.getAttribute("href");
    var activePane = document.querySelector(activePaneId);
    activePane.classList.add("active");
  }
  for (i = 0; i < myTabs.length; i++) {
    myTabs[i].addEventListener("click", myTabClicks);
  }
});
// Homepage Media Section Tabs-- End
